import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _backInStockItemDetails = { image: '_image' };
var _backInStockNotificationRequest = {
    createdDate: 'google.protobuf.Timestamp',
};
var _createBackInStockNotificationRequestRequest = {
    request: '_backInStockNotificationRequest',
    itemDetails: '_backInStockItemDetails',
};
var _createBackInStockNotificationRequestResponse = {
    request: '_backInStockNotificationRequest',
};
var _deleteBackInStockNotificationRequestRequest = {};
var _deleteBackInStockNotificationRequestResponse = {};
var _getBackInStockNotificationRequestRequest = {};
var _getBackInStockNotificationRequestResponse = {
    request: '_backInStockNotificationRequest',
};
var _getBackInStockNotificationRequestsCountByCatalogReferencesRequest = {};
var _getBackInStockNotificationRequestsCountByCatalogReferencesResponse = {};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _markAsNotificationSentRequest = {};
var _markAsNotificationSentResponse = {
    request: '_backInStockNotificationRequest',
};
var _queryBackInStockNotificationRequestsRequest = {};
var _queryBackInStockNotificationRequestsResponse = {
    requests: '_backInStockNotificationRequest',
};
var _reportItemsBackInStockRequest = {
    itemDetails: '_backInStockItemDetails',
};
var _reportItemsBackInStockResponse = {};
function resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/back-in-stock-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/back-in-stock-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/back-in-stock-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a back in stock notification request.
 *
 * If a notification request already exists for the same `catalogReference` and `email`,
 * then a new one isn't created and the existing request is returned.
 */
export function createBackInStockNotificationRequest(payload) {
    var _a = serializer(_createBackInStockNotificationRequestRequest, { _backInStockItemDetails: _backInStockItemDetails, _backInStockNotificationRequest: _backInStockNotificationRequest, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBackInStockNotificationRequestResponse, { _backInStockNotificationRequest: _backInStockNotificationRequest }).fromJSON;
    function __createBackInStockNotificationRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'POST',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.CreateBackInStockNotificationRequest',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBackInStockNotificationRequest.fromReq = fromReq;
    __createBackInStockNotificationRequest.__isAmbassador = true;
    return __createBackInStockNotificationRequest;
}
/** Retrieves a back in stock notification request. */
export function getBackInStockNotificationRequest(payload) {
    var _a = serializer(_getBackInStockNotificationRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBackInStockNotificationRequestResponse, { _backInStockNotificationRequest: _backInStockNotificationRequest }).fromJSON;
    function __getBackInStockNotificationRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'GET',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.GetBackInStockNotificationRequest',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBackInStockNotificationRequest.fromReq = fromReq;
    __getBackInStockNotificationRequest.__isAmbassador = true;
    return __getBackInStockNotificationRequest;
}
/** Deletes a back in stock notification request. */
export function deleteBackInStockNotificationRequest(payload) {
    var _a = serializer(_deleteBackInStockNotificationRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBackInStockNotificationRequestResponse, {}).fromJSON;
    function __deleteBackInStockNotificationRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'DELETE',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.DeleteBackInStockNotificationRequest',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBackInStockNotificationRequest.fromReq = fromReq;
    __deleteBackInStockNotificationRequest.__isAmbassador = true;
    return __deleteBackInStockNotificationRequest;
}
/**
 * Sets `status` of a back in stock request to `NOTIFICATION_SENT`.
 *
 * Use this endpoint if the notification is sent manually offline. If the notification is sent
 * automatically or with [Report Items Back In Stock](/report-items-back-in-stock), then `status` updates on its own.
 */
export function markAsNotificationSent(payload) {
    var _a = serializer(_markAsNotificationSentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsNotificationSentResponse, {
        _backInStockNotificationRequest: _backInStockNotificationRequest,
    }).fromJSON;
    function __markAsNotificationSent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'PUT',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.MarkAsNotificationSent',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests/{id}/mark-as-notification-sent',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsNotificationSent.fromReq = fromReq;
    __markAsNotificationSent.__isAmbassador = true;
    return __markAsNotificationSent;
}
/**
 * Retrieves a list of notification requests, given the provided paging, filtering, and sorting.
 *
 * For field support for filters and sorting, see [Back In Stock Requests: Supported Filters and Sorting]().
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryBackInStockNotificationRequests(payload) {
    var _a = serializer(_queryBackInStockNotificationRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBackInStockNotificationRequestsResponse, { _backInStockNotificationRequest: _backInStockNotificationRequest }).fromJSON;
    function __queryBackInStockNotificationRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'GET',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.QueryBackInStockNotificationRequests',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBackInStockNotificationRequests.fromReq = fromReq;
    __queryBackInStockNotificationRequests.__isAmbassador = true;
    return __queryBackInStockNotificationRequests;
}
/** Retrieves the amount of back in stock requests for a given `catalogReference` item. */
export function getBackInStockNotificationRequestsCountByCatalogReferences(payload) {
    var _a = serializer(_getBackInStockNotificationRequestsCountByCatalogReferencesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBackInStockNotificationRequestsCountByCatalogReferencesResponse, {}).fromJSON;
    function __getBackInStockNotificationRequestsCountByCatalogReferences(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'GET',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.GetBackInStockNotificationRequestsCountByCatalogReferences',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests/count-by-catalog-reference',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBackInStockNotificationRequestsCountByCatalogReferences.fromReq =
        fromReq;
    __getBackInStockNotificationRequestsCountByCatalogReferences.__isAmbassador = true;
    return __getBackInStockNotificationRequestsCountByCatalogReferences;
}
/**
 * Sends notifications for back in stock requests.
 *
 * > **Important:**
 * > Automations must be turned on in a [site's dashboard](https://www.wix.com/my-account/site-selector/?buttonText=Go%20to%20Back-in-Stock&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https://www.wix.com/dashboard/{{metaSiteId}}/store/back-in-stock) for notifications to send.
 *
 * This endpoint triggers notifications for requests in 1 of 2 ways:
 * 1. For a specific item, with the `catalogReference` information.
 * 2. For specific requests, with `requestIds`.
 *
 * `itemDetails` are required and may populate dynamic values in the notification template, as follows:
 * + `itemDetails.name` passes to the template as `item.name`
 * + `itemDetails.price` passes to the template as `item.price`
 * + `itemDetails.image.url` passes to the template as `item.image.url`
 *
 * If the notification template doesn't include `item.price`, `item.name`, or `item.image.url`, values should
 * be passed in `extraAutomationTemplateParameters`.
 *
 * After this endpoint is called, the `status` for the request will update to `NOTIFICATION_SENT` if it sends
 * successfully, or to `FAILED` if it fails to send.
 */
export function reportItemsBackInStock(payload) {
    var _a = serializer(_reportItemsBackInStockRequest, { _backInStockItemDetails: _backInStockItemDetails, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportItemsBackInStockResponse, {}).fromJSON;
    function __reportItemsBackInStock(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.back_in_stock_notification_request',
            method: 'POST',
            methodFqn: 'com.wixpress.ecom.back.in.stock.BackInStockNotificationRequestService.ReportItemsBackInStock',
            url: resolveComWixpressEcomBackInStockBackInStockNotificationRequestServiceUrl({
                protoPath: '/v1/back-in-stock-notification-requests/report-items-back-in-stock',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportItemsBackInStock.fromReq = fromReq;
    __reportItemsBackInStock.__isAmbassador = true;
    return __reportItemsBackInStock;
}
//# sourceMappingURL=http.impl.js.map